export interface OldPriceProductInterface {
  crossed?: boolean;
  old_price?: string | number | null;
  price: string | number;
}

export const canOldPriceShow = (product: OldPriceProductInterface) => {
  if (!product.crossed || !product.old_price) return false;
  return Number(product.price) !== Number(product.old_price);
};
